(() => {
  if (window.gsCompactSearchMounted) return;
  window.gsCompactSearchMounted = true;
  let opener;
  const panel = () => document.getElementById('gs-header-search');
  const sync = (expanded) => document.querySelectorAll('[data-gs-search-toggle]').forEach((toggle) => {
    toggle.setAttribute('aria-controls', 'gs-header-search');
    toggle.setAttribute('aria-expanded', String(expanded));
  });
  const setup = () => {
    const actions = document.querySelector('.sticky-header .header__bottom .header-actions');
    const source = document.querySelector('#site-header .header-actions [data-gs-search-toggle]');
    if (actions && source && !actions.querySelector('[data-gs-search-toggle]')) {
      actions.prepend(source.cloneNode(true));
    }
    sync(false);
    return Boolean(actions);
  };
  // .sticky-header'ı section-header.js (defer, bu dosyadan sonra yükleniyor) oluşturur.
  // Bu yüzden ilk çalışmada henüz yoksa body'ye eklenmesini bekle.
  const init = () => {
    if (setup()) return;
    const observer = new MutationObserver(() => {
      if (setup()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', setup);
  // Masaüstü: kutu, simgenin bulunduğu boş alanın üstünde düzen dışı açılır;
  // Hesap/Sepet düğmeleri yer değiştirmez, açıkken simge gizlenir.
  const placeOverlay = (search, toggle) => {
    const actions = toggle.parentElement;
    // Simgenin hemen arkasına eklenir: ilk/son öğe kuralları (kenar boşlukları) değişmez.
    toggle.after(search);
    search.classList.add('gs-compact-search--overlay');
    toggle.classList.add('gs-search-toggle--active');
    // Kutu bir sonraki düğmeye (Hesap/Sepet) kadar uzanır; aradaki bilgi bloğunu örter.
    let next = search.nextElementSibling;
    while (next && (!next.offsetParent || !next.matches('.button, [class*="button"]'))) next = next.nextElementSibling;
    const left = toggle.offsetLeft;
    const room = (next ? next.offsetLeft : actions.clientWidth) - left - 16;
    search.style.left = `${left}px`;
    search.style.width = `${Math.max(200, Math.min(360, room))}px`;
  };
  const clearOverlay = (search) => {
    search.classList.remove('gs-compact-search--overlay');
    search.style.left = '';
    search.style.width = '';
    document.querySelectorAll('.gs-search-toggle--active').forEach((t) => t.classList.remove('gs-search-toggle--active'));
  };
  const close = (restoreFocus = true) => {
    const search = panel();
    if (!search || search.hidden) return;
    search.hidden = true;
    clearOverlay(search);
    sync(false);
    if (restoreFocus && opener?.isConnected) opener.focus();
  };
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-gs-search-toggle]');
    const search = panel();
    if (toggle && search) {
      event.preventDefault();
      if (!search.hidden) return close();
      opener = toggle;
      const sticky = toggle.closest('.sticky-header');
      const header = document.getElementById('site-header');
      clearOverlay(search);
      if (window.matchMedia('(min-width: 1024px)').matches) placeOverlay(search, toggle);
      else if (sticky) sticky.append(search);
      else header.querySelector('.header-container--top').after(search);
      search.hidden = false;
      search.querySelector('search-form').a11yIndex = -1;
      sync(true);
      search.querySelector('input').focus();
    } else if (event.target.closest('[data-gs-search-close]')) close();
    else if (search && !search.contains(event.target)) close(false);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && panel() && !panel().hidden) {
      event.preventDefault();
      close();
    }
  });
  // Telefonda klavye ve adres çubuğu yalnız yüksekliği değiştirir; o yüzden
  // arama yalnız genişlik değişince kapanır (aksi halde açılır açılmaz kapanıyordu).
  let lastWidth = window.innerWidth;
  window.addEventListener('resize', () => {
    if (window.innerWidth === lastWidth) return;
    lastWidth = window.innerWidth;
    close(false);
  });
})();
